import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';
import { getRsvpByGuestUuid } from '../../../../actions/PublicWebsiteActions';


function formatGuest(guest) {
  let guestOutput;
  if (guest.relationship_type === 'PRIMARY') {
    guestOutput = `${guest.first_name} ${guest.family_name}`;
  }
  if (guest.first_name && guest.family_name) {
    guestOutput = `${guest.first_name} ${guest.family_name}`;
  } else if (guest.first_name) {
    guestOutput = `${guest.first_name}`;
  } else if (guest.family_name) {
    guestOutput = `${guest.family_name}`;
  } else {
    guestOutput = guest.relationship_type === 'CHILD' ? 'Child' : 'Guest';
    return guestOutput;
  }
  if (guest.suffix) {
    return `${guestOutput} ${guest.suffix}`;
  }
  return guestOutput;
}

function RenderGuestGroup(props) {
  const { guestGroup } = props;
  return (
    <ul className="guest-group-list list-unstyled">
      {guestGroup.guests.map(guest => (
        <li key={guest.uuid} className={guest.searched_for ? 'searched-for' : ''}>
          <p className="guest-group-li">{formatGuest(guest)}</p>
        </li>
      ))}
    </ul>
  );
}

RenderGuestGroup.propTypes = {
  guestGroup: PropTypes.shape({})
};

function formatLocation(city, stateProvince) {
  let location = '';
  if (city && stateProvince) {
    location = `${city}, ${stateProvince}`;
  } else if (city) {
    location = city;
  } else if (stateProvince) {
    location = stateProvince;
  }
  return location;
}

function SearchResultRow(props) {
  const { guestGroup, onSelectGuest } = props;
  return (
    <li className="search-result-item row">
      <div className="col-xs-12 col-sm-4 result-name">
        <RenderGuestGroup guestGroup={guestGroup} />
      </div>
      <div className="col-xs-12 col-sm-4 result-location">
        <p>{formatLocation(guestGroup.city, guestGroup.state_province)}</p>
      </div>
      <div className="col-xs-12 col-sm-4 select-button">
        <button className="btn btn-primary btn-wide" onClick={() => onSelectGuest(guestGroup.uuid)}>
          Select
        </button>
      </div>
    </li>
  );
}

SearchResultRow.propTypes = {
  guestGroup: PropTypes.shape({}),
  onSelectGuest: PropTypes.func
};

function SearchResultsList(props) {
  const { searchResults, onSelectGuest } = props;

  const sortByRelationshipType = (guest1, guest2) => {
    const rank = { CHILD: 2, PARTNER: 1, PRIMARY: 0 };
    return rank[guest1.relationship_type] - rank[guest2.relationship_type];
  };

  const formattedSearchResults = searchResults.reduce((acc, guestGroup) => {
    const guests = guestGroup.guests.sort(sortByRelationshipType);
    const formattedGuestGroup = Object.assign({}, guestGroup, { guests });
    acc.push(formattedGuestGroup);
    return acc;
  }, []);

  return (
    <ul className="search-results-list list-unstyled margin-bottom-2x">
      {formattedSearchResults.map(guestGroup => (
        <SearchResultRow key={guestGroup.uuid} guestGroup={guestGroup} onSelectGuest={onSelectGuest} />
      ))}
    </ul>
  );
}

SearchResultsList.propTypes = {
  searchResults: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.shape({}))]),
  onSelectGuest: PropTypes.func
};


function resetGuestSearchesNotActedOn() {
  const cookies = new Cookies();
  cookies.remove('guestSearchesNotActedOn');
  cookies.remove('rsvpSearchDisabled');
}

class GuestSearchResults extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rsvpSearchDisabled: false
    };
  }

  render() {
    const { searchResults, onSelectGuest, onRevealAccessForm, rsvpRequestEnabled } = this.props; // eslint-disable-line
    const notFound = searchResults[0] === 'NOT_FOUND';
    const disabled = searchResults[0] === 'DISABLED';
    const validResults = !notFound && !disabled;
    const multipleGuestResults = !validResults && searchResults && searchResults.length > 1;
    const suggested = searchResults.length > 0 && searchResults.every(guest => guest.suggested === true);
    let response;

    if (suggested) {
      response = {
        above: <p className="danger-text">Hm... we can&#39;t find your name. Did you mean...?</p>
      };
    } else if (multipleGuestResults) {
      response = {
        above: <p>We found multiple guests with that name. Select your information below or try searching again.</p>,
        below: <p>If none of these are you, please reach out to the couple<br />to see exactly how they entered your details.</p>
      };
    } else {
      response = {
        above: <p className="danger-text">Hm... we can&#39;t find your name. Make sure you enter your name exactly as it appears on your invitation.</p>,
      };
    }

    return (
      <div>
        <div className="guest-search-results">
          {disabled ? (
            <div>
              {rsvpRequestEnabled ? (
                <div className="padding-bottom-2x">
                  <p>Looks like you&#39;ve entered your name a few times.</p>
                  <p>Please reach out to the couple and request access to their RSVP page. <span className="request-btn" onClick={() => onRevealAccessForm()}>Contact The Couple &rsaquo;</span> </p>
                  {response.below}
                </div>
              ) : (
                <div className="padding-bottom-2x">
                  <p>Looks like you&#39;ve entered your name a few times.</p>
                  <p className="margin-bottom-2x">Please reach out to the couple<br />to see exactly how they entered your details.</p>
                </div>
              )}
            </div>
          ) : (
            <div>
              {(searchResults.length > 0) && (
                <div>
                  <div>
                    <div className="padding-bottom-2x">
                      {response.above}
                    </div>
                    {validResults && (
                      <SearchResultsList onSelectGuest={onSelectGuest} searchResults={searchResults} />
                    )}
                    {rsvpRequestEnabled ? (
                      <div className="padding-bottom-2x">
                        <p> Still having trouble? Reach out to the couple and request access to their RSVP page. <span className="request-btn" onClick={() => onRevealAccessForm()}>Contact The Couple &rsaquo;</span> </p>
                        {response.below}
                      </div>
                    ) : (
                      <p className="margin-bottom-2x">Please reach out to the couple<br />to see exactly how they entered your details.</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

GuestSearchResults.propTypes = {
  searchResults: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.shape({}))]),
  onSelectGuest: PropTypes.func.isRequired,
  onRevealAccessForm: PropTypes.func,
  rsvpRequestEnabled: PropTypes.bool
};

const mapDispatchToProps = dispatch => ({
  onSelectGuest: (guestUuid) => {
    resetGuestSearchesNotActedOn();
    return dispatch(getRsvpByGuestUuid(guestUuid));
  },
});

const mapStateToProps = state => ({
  slug: state.publicWebsite.wedding.slug,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GuestSearchResults);



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/rsvp/GuestSearchResults.jsx